import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/workspace/seongsudong/web/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
var _types$UPDATE_GNB$typ;
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as types from "./mutation_types";
import { UPDATE_CHART_POSTS } from "./mutation_types";
export default (_types$UPDATE_GNB$typ = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_types$UPDATE_GNB$typ, types.UPDATE_GNB, function (state, payload) {
  state.gnb = payload;
}), types.UPDATE_CATEGORIES, function (state, payload) {
  state.categories = payload;
}), types.UPDATE_LATEST_POSTS, function (state, payload) {
  state.latestPosts = payload;
}), types.UPDATE_CHART_POSTS, function (state, payload) {
  state.chartPosts = _objectSpread(_objectSpread({}, state.chartPosts), {}, _defineProperty({}, payload.key, payload.value));
}), types.UPDATE_CATE_POSTS, function (state, payload) {
  state.catePosts = _objectSpread(_objectSpread({}, state.catePosts), {}, _defineProperty({}, payload.key, payload.value));
}), types.UPDATE_CURRENT_CATE, function (state, payload) {
  state.currentCate = payload;
}), types.UPDATE_TAG_POSTS, function (state, payload) {
  state.tagPosts = _objectSpread(_objectSpread({}, state.tagPosts), {}, _defineProperty({}, payload.key, payload.value));
}), types.UPDATE_EDITOR_POSTS, function (state, payload) {
  state.editorPosts = _objectSpread(_objectSpread({}, state.editorPosts), {}, _defineProperty({}, payload.key, payload.value));
}), types.UPDATE_CURRENT_EDITOR, function (state, payload) {
  state.currentEditor = payload;
}), types.UPDATE_SEARCH_ARTICLES, function (state, payload) {
  state.searchArticles = _objectSpread(_objectSpread({}, state.searchArticles), {}, _defineProperty({}, payload.key, payload.value));
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_types$UPDATE_GNB$typ, types.PUSH_LIST_OF_CALLED_API, function (state, payload) {
  var index = state.listOfCalledAPI.indexOf(payload);
  if (index < 0) state.listOfCalledAPI.push(payload);
}), types.UPDATE_DISPLAY_CATE_DATA, function (state, payload) {
  state.displayCateData = payload;
}), types.UPDATE_DISPLAY_DATA, function (state, payload) {
  if (payload.length > 0) {
    state.displayData = state.displayData.concat(payload);
    state.isUpdatedDisplayData = true;
    setTimeout(function () {
      return state.isUpdatedDisplayData = false;
    });
  }
}), types.UPDATE_DISPLAY_PAGE, function (state, payload) {
  if (!state.displayPage.includes(payload)) state.displayPage.push(payload);
}), types.CHANGE_SIZE_TOAST_BANNER, function (state, payload) {
  state.smallToastBanner = payload;
}), types.CHANGE_OPEN_SHARE_DIALOG, function (state, payload) {
  state.openShareDialog = payload;
}), types.CHANGE_OPEN_FOOTER1_DIALOG, function (state, payload) {
  state.openFooter1Dialog = payload;
}), types.CHANGE_OPEN_FOOTER2_DIALOG, function (state, payload) {
  state.openFooter2Dialog = payload;
}), types.CHANGE_OPEN_FOOTER3_DIALOG, function (state, payload) {
  state.openFooter3Dialog = payload;
}), types.CHANGE_OPEN_FAQ_DIALOG, function (state, payload) {
  state.openFaqDialog = payload;
}), _defineProperty(_defineProperty(_defineProperty(_types$UPDATE_GNB$typ, types.CHANGE_OPEN_TEAM_DIALOG, function (state, payload) {
  state.openTeamDialog = payload;
}), types.UPDATE_OPEN_DROPDOWN, function (state, payload) {
  state.openTeamDropdown = payload;
}), types.UPDATE_CURRENT_CONTENTS_DATA, function (state, payload) {
  state.currentContentsData = payload;
}));